export default {
    name: 'DefaultSubscriptionModal',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '800px'
        },
        height: {
            type: String,
            default: 'auto'
        }
    },
    methods: {
        goToContactUs() {
            this.$router.push({ name: 'ContactUs' });
        }
    }
};
